<script>
import StaffContents from "@/components/gen/StaffContents.vue";

export default {
  name: "Staff04",
  components: {StaffContents},
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>

<template>
  <div>
    <StaffContents
        :profileImg="require('../../assets/img/gen/staff/04/profile.jpg')"
        :profileImgSp="require('../../assets/img/gen/staff/04/profile_sp.jpg')"
        profileAlt="04 藤野 早央里"
        answer01="中高生まではずっとバスケをやっていましたが、なにか新しいことに挑戦してみたいと思い、大学時代はカヌー部のマネージャーをしていました。何も知らないカヌー競技の世界へと飛び込めたのは、ロールモデルとなる先輩に出会えたから。当時4年生だった先輩がプレイヤー・マネージャーの垣根を越えてサポートしていたり、自分にできることを発見し率先して行動する姿を見て、自分も誰かを支えられる人になりたい！と思ったんです。プレイヤーからサポート側にまわってみて実感したやりがいがきっかけで、人の生活を支える仕事がしたいと思うようになりました。"
        answer02="就職活動では化学・素材メーカーを中心に見ていました。身の回りのあらゆる物は素材からできているため、人の生活に必要不可欠かつ幅広い技術発展の可能性がある分野だと考えたからです。クレハを選ぶ決め手になったのは、面接の際に社員の方と素直に会話ができたこと。私の好きな日本酒の話を起点に面接を進めていただいたのが印象的でした。肩書きや経歴といった情報から得る先入観ではなく、目の前で話す私の言葉から私自身のことを知ろうとする姿勢に感銘を受けました。素直な自分のままで働けるクレハでなら、自己成長ができると考え入社を決めました。"
        answer03="首都圏エリアのスーパーやドラッグストアへ向けて、「NEWクレラップ」「キチントさんシリーズ」をはじめとする家庭用品の営業活動をしています。具体的な業務としては、販売計画の作成・進捗報告や、より多くのお客様にクレハの製品を手に取ってもらえる売り場の企画提案など。販売店のバイヤーさんに対して、確実に売上へとつながるような説得力のある提案をするためには、自社商品の情報だけでなく、競合の情報を把握することも大切です。クレハ、代理店、販売店それぞれの利益を最大化できるような提案ができたときには大きなやりがいを感じます。"
        answer04="初めて担当した量販店で商品の売上回復に貢献したことです。その量販店では、NEWクレラップの値上げをきっかけとした売上減少に頭を悩ませていました。売り場の確認のため、全店舗を巡回すると、一部店舗では他店に比べて商品の売り場が目立っていないことに気づいたんです。そこで、データに基づく売上のシミュレーションに加え、NEWクレラップのセール期間にあわせてお客様の目につきやすい通路側の棚へと商品を展開する企画を提案したところ、値上げ前よりも売上が伸び、バイヤーさんからも感謝していただきました。販売の最前線を確認し、自分の目で課題を見つける重要性を実感する経験でした。"
        answer05="自分の担当量販店で扱っている「NEWクレラップ」と「キチントさんシリーズ」のシェア拡大はもちろんですが、企業向けの製品を扱う事業部での業務にも興味があります。これまでは消費者に一番近い部門で仕事をしながら、競合の動きや現状を把握したうえで課題を特定し、提案につなげるという営業の基礎を身につけてきました。この経験は異なる分野でも活かせるのではと考えています。多様な知見からチームを支えられる人になるのが目標なので、自分が獲得したいスキルや異動の希望を人事へと伝えられる「キャリア自己申告制度」を利用しながら、幅広く業務を経験したいです。"
        answer06="自己成長に向けたチャレンジを応援してくれるところです。クレハには、まず自分で考えてやってみようという風土があります。初めての担当先でお客様の目に留まる商品展開を提案した際には、これまでとは異なる方法だったにも関わらず、先輩が「やってみよう！」と背中を押してくれました。クレハのような環境にいることで、お客さんやバイヤーさんの希望を叶えるために自分になにができるのか？そういった視点を持って仕事に取り組むようになりました。難しい問題があったときには、自分なりに結論を出したうえで、上司に相談することを心がけています。"
        :imageCut01="require('../../assets/img/gen/staff/04/image01.jpg')"
        :imageCut02="require('../../assets/img/gen/staff/04/image02.jpg')"
        :imageCut01Sp="require('../../assets/img/gen/staff/04/image01_sp.jpg')"
        :imageCut02Sp="require('../../assets/img/gen/staff/04/image02_sp.jpg')"
        :schedule="require('../../assets/img/gen/staff/04/schedule.png')"
        :scheduleSp="require('../../assets/img/gen/staff/04/schedule_sp.png')"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
